import { IPlanWeekItem } from "../../domain/models/plan/plan-week-item.model";

/**
 * What the board is allowed to offer. The student planner and the coach's copy of it show the same
 * board; what differs is which actions the viewer may take.
 */
export interface IPlannerConfig {
  /** Ticking items off, deleting, duplicating and moving them to another week. */
  canEdit: boolean;
  /** The "Konu Ekle" button on each lesson column. */
  canAddTopic: boolean;
  /** The scheduled day and hour under an item. */
  showAssignedTime: boolean;
}

export const DEFAULT_PLANNER_CONFIG: IPlannerConfig = {
  canEdit: true,
  canAddTopic: true,
  showAssignedTime: true,
};

/** An item together with where it sits, which is what the API calls need. */
export interface IPlannerItemEvent {
  item: IPlanWeekItem;
  index: number;
}
